import { Route, Switch } from 'react-router-dom';
import React from 'react';
import SideBar from './SideBar';
import css from './Admin.module.css';
import { ProfileModalProvider } from '../GroupOwner/ProfileModalContext';
import AccountProfileModal from '../GroupOwner/AccountProfileModal';

const SubscriptionList = React.lazy(() => import('./SubscriptionList'));
const AccountList = React.lazy(() => import('./AccountList'));

export const AdminBasePath = '/admin';
export const AdminSwitch = () => {
  return (
    <ProfileModalProvider>
      <AccountProfileModal />
      <div className={css.container}>
        <Switch>
          <Route path={`${AdminBasePath}/`}>
            <SideBar />
          </Route>
        </Switch>
        <div className={css.body}>
          <div className={css.scrollContent}>
            <Switch>
              <Switch>
                <Route exact path={`${AdminBasePath}/`}>
                  <AccountList />
                </Route>
                <Route exact path={`${AdminBasePath}/:userId/subscriptions`}>
                  <SubscriptionList />
                </Route>
              </Switch>
            </Switch>
          </div>
        </div>
      </div>
    </ProfileModalProvider>
  );
};

export default AdminSwitch;
